const numberToTerm = number => {
  if (number === 0) return 'once';
  return number === 12 ? 'annual' : 'monthly';
};
/**
 * Transforms price shape to match PricingInfo for HighlightedPriceDisplay components
 * TODO: remove this once HighlightedPriceDisplay can accept the raw response shape
 */
const shapePricesByTerm = (purchaseOption, commitmentTerm) => {
  const commitmentTermString = numberToTerm(commitmentTerm);
  return {
    monthly: {
      fullPrice: Number(purchaseOption.listPrice.monthlyPrice),
      calculatedPrice: Number(purchaseOption.discountedPrice.monthlyPrice)
    },
    annually: {
      fullPrice: Number(commitmentTermString === 'annual' ? purchaseOption.listPrice.priceForCommittedPeriod : purchaseOption.listPrice.monthlyPrice),
      calculatedPrice: Number(commitmentTermString === 'annual' ? purchaseOption.discountedPrice.priceForCommittedPeriod : purchaseOption.discountedPrice.monthlyPrice)
    },
    oneTimeFee: commitmentTerm === 0 ? {
      fullPrice: Number(purchaseOption.listPrice.priceForCommittedPeriod),
      calculatedPrice: Number(purchaseOption.discountedPrice.priceForCommittedPeriod)
    } : undefined
  };
};
const shapeMultiTermPurchaseOption = (multiTermPurchaseOption, currencyCode) => {
  var _multiTermPurchaseOpt, _multiTermPurchaseOpt2, _multiTermPurchaseOpt3, _multiTermPurchaseOpt4, _multiTermPurchaseOpt5, _multiTermPurchaseOpt6, _multiTermPurchaseOpt7, _multiTermPurchaseOpt8, _multiTermPurchaseOpt9, _multiTermPurchaseOpt10, _multiTermPurchaseOpt11, _multiTermPurchaseOpt12, _multiTermPurchaseOpt13, _multiTermPurchaseOpt14;
  const commitmentTerm = numberToTerm(multiTermPurchaseOption.commitmentTerm);
  const paymentTerm = numberToTerm(multiTermPurchaseOption.paymentTerm);
  const recurringDiscountAmount = 100 - 100 * (Number(multiTermPurchaseOption.recurringTermDiscountedPrice.priceForCommittedPeriod) / Number(multiTermPurchaseOption.recurringTermListPrice.priceForCommittedPeriod)) || 0;
  const nonRecurringDiscountAmount = 100 - 100 * (Number(multiTermPurchaseOption.nonRecurringTermDiscountedPrice.price) / Number(multiTermPurchaseOption.nonRecurringTermListPrice.price)) || 0;
  const discountAmount = recurringDiscountAmount || nonRecurringDiscountAmount;
  const priceBreakdown = {
    offerInfo: {
      commitment: commitmentTerm,
      payment: paymentTerm,
      discount: discountAmount
    },
    skuUuid: (multiTermPurchaseOption === null || multiTermPurchaseOption === void 0 || (_multiTermPurchaseOpt = multiTermPurchaseOption.recurringPricedProductBySkuUuid) === null || _multiTermPurchaseOpt === void 0 || (_multiTermPurchaseOpt = _multiTermPurchaseOpt.skuUuid) === null || _multiTermPurchaseOpt === void 0 ? void 0 : _multiTermPurchaseOpt.skuUuid) || (multiTermPurchaseOption === null || multiTermPurchaseOption === void 0 || (_multiTermPurchaseOpt2 = multiTermPurchaseOption.nonRecurringPricedProductBySkuUuid) === null || _multiTermPurchaseOpt2 === void 0 || (_multiTermPurchaseOpt2 = _multiTermPurchaseOpt2.skuUuid) === null || _multiTermPurchaseOpt2 === void 0 ? void 0 : _multiTermPurchaseOpt2.skuUuid),
    quantity: 1,
    commitmentTerm: multiTermPurchaseOption === null || multiTermPurchaseOption === void 0 ? void 0 : multiTermPurchaseOption.commitmentTerm,
    paymentTerm: multiTermPurchaseOption === null || multiTermPurchaseOption === void 0 ? void 0 : multiTermPurchaseOption.paymentTerm,
    discounts: [],
    listPrice: {
      currencyCode: currencyCode,
      dueUponPurchase: (multiTermPurchaseOption === null || multiTermPurchaseOption === void 0 || (_multiTermPurchaseOpt3 = multiTermPurchaseOption.recurringTermListPrice) === null || _multiTermPurchaseOpt3 === void 0 ? void 0 : _multiTermPurchaseOpt3.dueUponPurchase) || (multiTermPurchaseOption === null || multiTermPurchaseOption === void 0 || (_multiTermPurchaseOpt4 = multiTermPurchaseOption.nonRecurringTermListPrice) === null || _multiTermPurchaseOpt4 === void 0 ? void 0 : _multiTermPurchaseOpt4.price),
      priceForCommittedPeriod: (multiTermPurchaseOption === null || multiTermPurchaseOption === void 0 || (_multiTermPurchaseOpt5 = multiTermPurchaseOption.recurringTermListPrice) === null || _multiTermPurchaseOpt5 === void 0 ? void 0 : _multiTermPurchaseOpt5.priceForCommittedPeriod) || (multiTermPurchaseOption === null || multiTermPurchaseOption === void 0 || (_multiTermPurchaseOpt6 = multiTermPurchaseOption.nonRecurringTermListPrice) === null || _multiTermPurchaseOpt6 === void 0 ? void 0 : _multiTermPurchaseOpt6.price),
      monthlyPrice: (multiTermPurchaseOption === null || multiTermPurchaseOption === void 0 || (_multiTermPurchaseOpt7 = multiTermPurchaseOption.recurringTermListPrice) === null || _multiTermPurchaseOpt7 === void 0 ? void 0 : _multiTermPurchaseOpt7.monthlyPrice) || (multiTermPurchaseOption === null || multiTermPurchaseOption === void 0 || (_multiTermPurchaseOpt8 = multiTermPurchaseOption.nonRecurringTermListPrice) === null || _multiTermPurchaseOpt8 === void 0 ? void 0 : _multiTermPurchaseOpt8.price)
    },
    discountedPrice: {
      currencyCode: currencyCode,
      dueUponPurchase: (multiTermPurchaseOption === null || multiTermPurchaseOption === void 0 || (_multiTermPurchaseOpt9 = multiTermPurchaseOption.recurringTermDiscountedPrice) === null || _multiTermPurchaseOpt9 === void 0 ? void 0 : _multiTermPurchaseOpt9.dueUponPurchase) || (multiTermPurchaseOption === null || multiTermPurchaseOption === void 0 || (_multiTermPurchaseOpt10 = multiTermPurchaseOption.nonRecurringTermListPrice) === null || _multiTermPurchaseOpt10 === void 0 ? void 0 : _multiTermPurchaseOpt10.price),
      priceForCommittedPeriod: (multiTermPurchaseOption === null || multiTermPurchaseOption === void 0 || (_multiTermPurchaseOpt11 = multiTermPurchaseOption.recurringTermDiscountedPrice) === null || _multiTermPurchaseOpt11 === void 0 ? void 0 : _multiTermPurchaseOpt11.priceForCommittedPeriod) || (multiTermPurchaseOption === null || multiTermPurchaseOption === void 0 || (_multiTermPurchaseOpt12 = multiTermPurchaseOption.nonRecurringTermDiscountedPrice) === null || _multiTermPurchaseOpt12 === void 0 ? void 0 : _multiTermPurchaseOpt12.price),
      monthlyPrice: (multiTermPurchaseOption === null || multiTermPurchaseOption === void 0 || (_multiTermPurchaseOpt13 = multiTermPurchaseOption.recurringTermDiscountedPrice) === null || _multiTermPurchaseOpt13 === void 0 ? void 0 : _multiTermPurchaseOpt13.monthlyPrice) || (multiTermPurchaseOption === null || multiTermPurchaseOption === void 0 || (_multiTermPurchaseOpt14 = multiTermPurchaseOption.nonRecurringTermDiscountedPrice) === null || _multiTermPurchaseOpt14 === void 0 ? void 0 : _multiTermPurchaseOpt14.price)
    }
  };
  const recurringProductsPriceBreakdown = {
    monthly: {
      fullPrice: Number(multiTermPurchaseOption.recurringTermListPrice.monthlyPrice),
      calculatedPrice: Number(multiTermPurchaseOption.recurringTermDiscountedPrice.monthlyPrice)
    },
    annually: {
      fullPrice: Number(commitmentTerm === 'annual' ? multiTermPurchaseOption.recurringTermListPrice.priceForCommittedPeriod : multiTermPurchaseOption.recurringTermListPrice.monthlyPrice),
      calculatedPrice: Number(commitmentTerm === 'annual' ? multiTermPurchaseOption.recurringTermDiscountedPrice.priceForCommittedPeriod : multiTermPurchaseOption.recurringTermDiscountedPrice.monthlyPrice)
    }
  };
  const nonRecurringProductsPriceBreakdown = {
    oneTimeFee: {
      fullPrice: Number(multiTermPurchaseOption.nonRecurringTermListPrice.price),
      calculatedPrice: Number(multiTermPurchaseOption.nonRecurringTermDiscountedPrice.price)
    }
  };
  return Object.assign({}, recurringProductsPriceBreakdown, nonRecurringProductsPriceBreakdown, priceBreakdown, {
    perProductPricing: Object.assign({}, multiTermPurchaseOption.recurringPricedProductBySkuUuid, multiTermPurchaseOption.nonRecurringPricedProductBySkuUuid)
  });
};

/**
 * Transforms the response from the bulk purchasable products request data structure grouped by apiName
 * TODO: remove this once we migrate to the new on-demand purchasable products endpoint or response
 */
export const transformAllPurchasableProductsResponse = data => {
  var _data$purchasableProd;
  const transformedPurchasableProducts = data === null || data === void 0 || (_data$purchasableProd = data.purchasableProducts) === null || _data$purchasableProd === void 0 ? void 0 : _data$purchasableProd.reduce((purchasableProducts, purchasableProduct) => {
    // Highest monthly price first
    const sortedPurchaseOptions = [...purchasableProduct.purchaseOptions].sort((a, b) => {
      const commitmentTermSort = a.commitmentTerm - b.commitmentTerm;
      const paymentTermSort = a.paymentTerm - b.paymentTerm;
      const priceSort = Number(b.discountedPrice.monthlyPrice) - Number(a.discountedPrice.monthlyPrice);
      if (commitmentTermSort !== 0) return commitmentTermSort;
      if (paymentTermSort !== 0) return paymentTermSort;
      return priceSort;
    });
    const transformedPurchaseOptions = sortedPurchaseOptions.map(purchaseOption => {
      const commitmentTerm = numberToTerm(purchaseOption.commitmentTerm);
      const paymentTerm = numberToTerm(purchaseOption.paymentTerm);
      const discountAmount = 100 - 100 * (Number(purchaseOption.discountedPrice.priceForCommittedPeriod) / Number(purchaseOption.listPrice.priceForCommittedPeriod));
      const pricesByTerm = shapePricesByTerm(purchaseOption, purchaseOption.commitmentTerm);
      return Object.assign({}, purchaseOption, {
        offerInfo: {
          commitment: commitmentTerm,
          payment: paymentTerm,
          discount: discountAmount
        },
        skuUuid: purchasableProduct.skuUuid,
        quantity: 1,
        monthly: pricesByTerm.monthly,
        annually: pricesByTerm.annually,
        oneTimeFee: pricesByTerm.oneTimeFee
      });
    });
    purchasableProducts[purchasableProduct.productApiName] = Object.assign({}, purchasableProduct, {
      purchaseOptions: transformedPurchaseOptions
    });
    return purchasableProducts;
  }, {});
  return {
    allPurchaseableProducts: transformedPurchasableProducts,
    releaseInsights: data.releaseInsights
  };
};

/**
 * Transforms the response from the products purchase options request data structure grouped by products list
 */
export const transformFindPurchaseOptionsResponse = (data, products) => {
  var _data$purchaseOptions;
  const currencyCode = (data === null || data === void 0 ? void 0 : data.currencyCode) || 'USD';
  const flattenedPurchaseOptions = data === null || data === void 0 || (_data$purchaseOptions = data.purchaseOptions) === null || _data$purchaseOptions === void 0 ? void 0 : _data$purchaseOptions.map(option => option === null || option === void 0 ? void 0 : option.orderedTerms[0])
  // Only return options that have all products.  This is a stopgap until FinTech is able to complete the term consolidation work
  .filter(option => Object.keys(option.nonRecurringPricedProductBySkuUuid).length + Object.keys(option.recurringPricedProductBySkuUuid).length === (products === null || products === void 0 ? void 0 : products.length))
  // Sort by highest monthly price first, then lowest terms
  .sort((a, b) => {
    const commitmentTermSort = a.commitmentTerm - b.commitmentTerm;
    const paymentTermSort = a.paymentTerm - b.paymentTerm;
    const priceSort = Number(b.recurringTermDiscountedPrice.monthlyPrice) - Number(a.recurringTermDiscountedPrice.monthlyPrice);
    if (commitmentTermSort !== 0) return commitmentTermSort;
    if (paymentTermSort !== 0) return paymentTermSort;
    return priceSort;
  });
  const transformedPurchaseOptions = flattenedPurchaseOptions.map(multiTermPurchaseOption => shapeMultiTermPurchaseOption(multiTermPurchaseOption, currencyCode));
  return transformedPurchaseOptions;
};
export const transformPagedQuantityPackResponse = (data, commitmentTerm, paymentTerm) => {
  const transformedResponse = {
    stepSize: data.stepSize,
    hasMore: data.hasMore,
    offset: data.offset,
    quantities: {}
  };
  data.results.forEach(result => {
    const pricesByTerm = shapePricesByTerm(result, commitmentTerm);
    transformedResponse.quantities[result.quantity] = Object.assign({}, result, {
      monthly: pricesByTerm.monthly,
      annually: pricesByTerm.annually,
      offerInfo: {
        commitment: numberToTerm(commitmentTerm),
        payment: numberToTerm(paymentTerm)
      }
    });
  });
  return transformedResponse;
};